var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../common-theme/api/agency.service';
import { Injector } from '@angular/core';
import { ContactBaseComponent } from './../common-theme/index';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
var ContactComponent = /** @class */ (function (_super) {
    __extends(ContactComponent, _super);
    function ContactComponent(injector, agencyService, openModalService, document, window) {
        var _this = _super.call(this, injector, agencyService, window) || this;
        _this.openModalService = openModalService;
        _this.document = document;
        _this.window = window;
        _this.zoom = 13;
        return _this;
    }
    ContactComponent.prototype.openMessageModal = function () {
        this.openModalService.showContactFormModal();
        this.document.body.classList.add('no-scroll');
    };
    ContactComponent.prototype.clickedMarker = function (latitude, longitude) {
        if (this.window) {
            this.window.open('https://maps.google.com?daddr='
                + latitude + ','
                + longitude + '&amp;ll=');
        }
    };
    return ContactComponent;
}(ContactBaseComponent));
export { ContactComponent };



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts.pre-build-optimizer.js